import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";

function isEmpty(value) {
  return isNull(value) || isUndefined(null);
}

export default isEmpty;
